export default __webpack_public_path__ + "static/media/hacklytics.c0ec890f.png";